import { mergeSxProps } from "@clipboard-health/ui-components";
import { Stack, type StackProps } from "@mui/material";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface InsightContentWrapperProps extends StackProps {}

export function InsightContentWrapper(props: InsightContentWrapperProps) {
  const { sx, ...restProps } = props;

  return (
    <Stack
      sx={mergeSxProps(
        { flexDirection: "column", alignItems: "stretch", gap: 5, padding: 5, textAlign: "start" },
        sx
      )}
      {...restProps}
    />
  );
}
